import { render, staticRenderFns } from "./BookingsCard.vue?vue&type=template&id=0bb085f4&"
import script from "./BookingsCard.vue?vue&type=script&lang=js&"
export * from "./BookingsCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingsCard.vue?vue&type=style&index=0&id=0bb085f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports